import React from 'react';
import PopUp from '@/common/components/PopUp';
import useCallAnalysisDetail from '../hooks/useCallAnalysisDetail';
import { DetailPopupContent, DetailTitle } from '../callAnalysis.styles';
import AnalysisMeta from './callAnalysisDetail/AnalysisMeta';
import AnalysisSummary from './callAnalysisDetail/AnalysisSummary';
import AnalysisTranscript from './callAnalysisDetail/AnalysisTranscript';
import CriticalErrorsSection from './callAnalysisDetail/CriticalErrorsSection';
import SectionScoresSection from './callAnalysisDetail/SectionScoresSection';
import CriteriaSection from './callAnalysisDetail/CriteriaSection';
import ItemsListSection from './callAnalysisDetail/ItemsListSection';
import ManualReviewSection from './callAnalysisDetail/ManualReviewSection';
import HistorySection from './callAnalysisDetail/HistorySection';
import ReviewPanel from './callAnalysisDetail/ReviewPanel';

const CallAnalysisDetail = ({ analysis, setShow, onUpdated }) => {
	const {
		localAnalysis,
		storedDocumentId,
		reviewMode,
		setReviewMode,
		setComment,
		correctedScore,
		setCorrectedScore,
		setFeedback,
		showTranscript,
		transcripts,
		transcriptError,
		transcriptLoading,
		handleToggleTranscript,
		handleReview,
		handleReanalyze,
	} = useCallAnalysisDetail({ analysis, onUpdated });

	if (!localAnalysis) {
		return null;
	}

	return (
		<PopUp setShow={setShow} minWidth='min(960px, 92vw)'>
			<DetailPopupContent>
				<DetailTitle>AI Analysis</DetailTitle>

				<AnalysisMeta analysis={localAnalysis} />
				<AnalysisSummary summary={localAnalysis.summary} />
				<AnalysisTranscript
					storedDocumentId={storedDocumentId}
					showTranscript={showTranscript}
					transcripts={transcripts}
					transcriptError={transcriptError}
					transcriptLoading={transcriptLoading}
					onToggle={handleToggleTranscript}
				/>
				<CriticalErrorsSection
					criticalErrors={localAnalysis.critical_errors}
				/>
				<SectionScoresSection sections={localAnalysis.sections} />
				<CriteriaSection sections={localAnalysis.sections} />
				<ItemsListSection
					title='Fulfilled'
					items={localAnalysis.fulfilled_items}
				/>
				<ItemsListSection
					title='Missing / incomplete'
					items={localAnalysis.missing_items}
				/>
				<ItemsListSection
					title='Recommendations'
					items={localAnalysis.recommendations}
				/>
				<ManualReviewSection manualReview={localAnalysis.manual_review} />
				<HistorySection history={localAnalysis.history} />
				<ReviewPanel
					reviewMode={reviewMode}
					setReviewMode={setReviewMode}
					correctedScore={correctedScore}
					setCorrectedScore={setCorrectedScore}
					setComment={setComment}
					setFeedback={setFeedback}
					onReview={handleReview}
					onReanalyze={handleReanalyze}
				/>
			</DetailPopupContent>
		</PopUp>
	);
};

export default CallAnalysisDetail;
